<template>
  <article class="culture-wrapper">
    <div class="container">
      <ul class="sns-wrapper">
        <li>
          <a href="https://www.instagram.com/carrotglobal" target="_blank">
            <img
              src="@/assets/img/newGlobal/main/culture/sns1.png"
              alt="instagram"
            />
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/thecarrotglobal" target="_blank">
            <img
              src="@/assets/img/newGlobal/main/culture/sns2.png"
              alt="facebook"
            />
          </a>
        </li>
        <li>
          <a href="https://blog.naver.com/carrot_global" target="_blank">
            <img
              src="@/assets/img/newGlobal/main/culture/sns3.png"
              alt="blog"
            />
          </a>
        </li>
      </ul>
      <a href="https://www.instagram.com/carrotglobal/" target="_blank">
        <ul class="img-wrapper">
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg1.png" alt="img" />
            <p>@carrotglobal</p>
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg2.jpg" alt="img" />
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg3.jpg" alt="img" />
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg4.jpg" alt="img" />
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg5.jpg" alt="img" />
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg6.jpg" alt="img" />
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg7.jpg" alt="img" />
          </li>
          <li>
            <img src="@/assets/img/newGlobal/main/culture/bg8.jpg" alt="img" />
          </li>
        </ul>
      </a>
    </div>
  </article>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.culture-wrapper {
  padding: 40px 0;
  background-color: #f7f7f7;

  .sns-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 0 5px;
    margin-bottom: 10px;
  }

  .img-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    li {
      position: relative;

      img {
        width: 100%;
      }

      p {
        position: absolute;
        top: 70px;
        left: 35px;
        color: #ffffff;
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .culture-wrapper {
    padding: 80px 0;

    .img-wrapper {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
